var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailRole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734334612934,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 34545,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.112 100.864a215.456 215.456 0 0 0-213.504 217.088v0.512a214.912 214.912 0 0 0 203.776 224.768c117.76 5.632 218.112-85.504 224.256-203.776a143.648 143.648 0 0 0 0-20.992 216.448 216.448 0 0 0-214.528-217.6z m138.752 429.056a250.784 250.784 0 0 1-138.24 41.984A244.576 244.576 0 0 1 273.92 529.92a324.896 324.896 0 0 0-181.76 291.328c0 97.28 326.656 123.904 511.488 82.432v-101.376l-44.544-44.544-18.432-17.408 18.432-17.408 44.544-44.544v-89.6h27.136a320.448 320.448 0 0 0-81.92-58.88z m331.264 261.632l51.712-52.224-51.712-52.736v-73.216h-74.24l-51.712-52.224-51.712 52.224h-74.24v73.216l-51.712 52.736 51.712 52.736v73.216h74.24l51.712 52.736 51.712-52.736h74.24v-73.728z",
    "p-id": 34546,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailRole);
export default __webpack_public_path__ + "static/media/detail-role.8dd0134879837686309757a31a7a5560.svg";
export { ForwardRef as ReactComponent };